import { Loader } from 'react-feather';

import { cn } from '@/shared/utils/cn';
import { ButtonProps } from '@/shared/types/CommonTypes';

const baseClasses = cn(
  'relative inline-flex items-center justify-center rounded-full font-semibold cursor-pointer',
  'disabled:cursor-not-allowed disabled:opacity-50',
);

const variantClasses = {
  primary: 'bg-[#95699f] text-white hover:bg-[#81528e]',
  secondary: 'bg-[#4a4a4a] text-white hover:bg-[#222]',
  outline:
    'border-2 border-[#b995be] bg-white text-[#b995be] hover:border-transparent hover:bg-[#95699f] hover:text-white',
  ghost: 'bg-transparent text-[#444]',
} as const;

const sizeClasses = {
  xs: 'h-8 px-3 text-sm gap-1.5',
  sm: 'h-9 px-4 text-base gap-1.5',
  md: 'h-10 px-6 text-base gap-2',
  lg: 'h-12 px-8 text-lg gap-2.5',
  icon: 'h-6 w-6 p-0 gap-0',
} as const;

const Button = ({
  children,
  type,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  isLoading = false,
  leftIcon,
  rightIcon,
  className,
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      type={type || 'button'}
      disabled={disabled || isLoading}
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        fullWidth && 'w-full',
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          'inline-flex items-center gap-2',
          isLoading && 'opacity-0',
        )}
      >
        {leftIcon && <span>{leftIcon}</span>}
        {children}
        {rightIcon && <span>{rightIcon}</span>}
      </span>

      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Loader className="h-6 w-6 animate-spin text-current" aria-hidden />
        </span>
      )}
    </button>
  );
};

export default Button;
